

import { createResource, createSignal, createMemo, onCleanup, onMount, Show, For, Switch } from "solid-js";

import { useAdminContext } from "./AdminContext";
import { useUserContext } from "./UserContext";
import { useI18n } from "./i18n";


export default (props) => {
  const t = useI18n();
  const [showModal, setShowModal] = createSignal(false);
  const [selectedPromo, setSelectedPromo] = createSignal(null);
  const [selectedTeacher, setSelectedTeacher] = createSignal(null);
  const [availableTeachers, setAvailableTeachers] = createSignal([]);

  const [adminStore, setAdminStore, {
    editPromo,
    deletePromo,
    addPromo,
    addPromoValidator,
    deletePromoValidator
  }] = useAdminContext();

  const [userStore, setUserStore, userActions] = useUserContext();
  
  return <>
    <div><button
      type="button"
      class="btn btn btn-primary btn-sm"
      onClick={() => {
        const name = prompt(t("Nom ?"), "");
        addPromo({ name });
      }}>{t("Add Promo")}</button></div>
    <table class="table table-striped  table-hover">
      <thead>
        <tr>
          <th scope="col">Id</th>
          <th scope="col">{t("Name")}</th>
          <th scope="col">{t("Validators")}</th>
          <th scope="col">{t("Actions")}</th>
        </tr>
      </thead>
      <tbody>
        <For each={Object.values(userStore.promos_by_id)}>
          {(promo, index) => <tr>
            <td scope="row">{promo.id}</td>
            <td>
              <Show when={promo.editing} fallback={promo.name}>
                <input class="form-control"
                  value={promo.nameInput}
                  onInput={(e) => setUserStore('promos_by_id', promo.id, { nameInput: e.target.value })
                  } />
              </Show>
            </td>
            <td>
              <div class="d-flex flex-column">
                <Show when={promo.validators && promo.validators.length > 0} fallback={<span class="text-muted">{t("No validators")}</span>}>
                  <For each={promo.validators}>
                    {(validator) => (
                      <div class="d-flex align-items-center mb-1">
                        <span>
                          {validator.fullname ? (
                            <>{validator.fullname} <small class="text-muted">({validator.username})</small></>
                          ) : (
                            validator.username
                          )}
                        </span>
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-sm ms-2"
                          title={t("Remove validator")}
                          onClick={() => deletePromoValidator(promo.id, validator.id)}
                        >
                          &times;
                        </button>
                      </div>
                    )}
                  </For>
                </Show>
                <button 
                  type="button" 
                  class="btn btn-outline-primary btn-sm mt-2" 
                  onClick={() => {
                    // Find teachers
                    const teachers = adminStore.users.filter(user => user.role === 'teacher');
                    
                    // If no teachers, alert and return
                    if (teachers.length === 0) {
                      alert(t('No teachers available. Please add teacher users first.'));
                      return;
                    }
                    
                    // Get current validator IDs to filter out
                    const currentValidatorIds = promo.validators ? promo.validators.map(v => v.id) : [];
                    
                    // Filter out teachers who are already validators
                    const available = teachers.filter(teacher => 
                      !currentValidatorIds.includes(teacher.id)
                    );
                    
                    if (available.length === 0) {
                      alert(t('All teachers are already validators for this promo.'));
                      return;
                    }
                    
                    // Open modal with available teachers
                    setSelectedPromo(promo);
                    setAvailableTeachers(available);
                    setSelectedTeacher(available[0].id);
                    setShowModal(true);
                  }}
                >
                  {t("Add Validator")}
                </button>
              </div>
            </td>
            <td>
              <Show when={promo.editing}>
                <button
                  type="button"
                  class="btn btn btn-outline-primary btn-sm"
                  onClick={() => {
                    setUserStore('promos_by_id', promo.id, 'editing', false);
                    editPromo(promo.id, {name: promo.nameInput});
                  }}>{t("save")}</button>
              </Show>
              <Show when={!promo.editing}>
                <button
                  type="button"
                  class="btn btn btn-outline-info btn-sm"
                  onClick={() => setUserStore('promos_by_id', promo.id, {
                    editing: true,
                    nameInput: promo.name,
                  })}>{t("edit")}</button>
              </Show>
              {' '}
              <button
                type="button"
                class="btn btn btn-outline-danger btn-sm"
                onClick={() => {
                  alert(t('Not implemented'));
                  /*
                  if (confirm('Confirm deletion')) {
                    deletePromo(promo.id)
                    setUserStore('promos_by_id', promo.id, undefined);
                  }*/
                }}>{t("delete")}</button></td>
          </tr>
          }
        </For>
      </tbody>
    </table>

    {/* Validator Selection Modal */}
    <Show when={showModal()}>
      <div class="modal d-block" tabindex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }}>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{t("Add Validator to")} {selectedPromo()?.name}</h5>
              <button type="button" class="btn-close" aria-label="Close" onClick={() => setShowModal(false)}></button>
            </div>
            <div class="modal-body">
              <form>
                <div class="mb-3">
                  <label for="teacher-select" class="form-label">{t("Select a teacher to add as validator:")}</label>
                  <select 
                    id="teacher-select" 
                    class="form-select"
                    value={selectedTeacher()}
                    onChange={(e) => setSelectedTeacher(Number(e.target.value))}
                  >
                    <For each={availableTeachers()}>
                      {(teacher) => (
                        <option value={teacher.id}>
                          {teacher.fullname || teacher.username}
                        </option>
                      )}
                    </For>
                  </select>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" onClick={() => setShowModal(false)}>{t("cancel")}</button>
              <button 
                type="button" 
                class="btn btn-primary" 
                onClick={() => {
                  if (selectedPromo() && selectedTeacher()) {
                    addPromoValidator(selectedPromo().id, selectedTeacher());
                    setShowModal(false);
                  }
                }}
              >
                {t("Add Validator")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Show>
  </>;
}
